import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { AgGridModule } from '@ag-grid-community/angular';
import { CoModule } from 'src/app/core/modules/common/co.module';

import { MaterialModule } from '../../core/modules/material/material.module';
import { AITPipesModule } from '../../core/modules/pipes/pipes.module';
import { SingleGuardianLogEntryComponent } from './components/single-guardian-log-entry/single-guardian-log-entry.component';
import { SingleLogEntryComponent } from './components/single-log-entry/single-log-entry.component';
import { SyncHistoryDialogComponent } from './components/sync-history-dialog/sync-history-dialog.component';

@NgModule({
  declarations: [SyncHistoryDialogComponent, SingleLogEntryComponent, SingleGuardianLogEntryComponent],
  imports: [
    CommonModule,
    CoModule,
    MaterialModule,
    FlexLayoutModule,
    AgGridModule,
    AITPipesModule
  ]
})
export class SyncHistoryModule { }
